<template>
  <q-dialog v-model="showModal" @hide="onHide">
    <q-card class="campaign-calendar-modal">
      <q-linear-progress :value="1" class="bg-primary" />
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title class="text-h6">
          {{ $gettext('SCHEDULED_DATES') }}
        </q-toolbar-title>
        <q-btn v-close-popup flat round dense icon="close" />
      </q-toolbar>

      <q-card-section class="q-pa-md">
        <div v-if="campaign" class="campaign-name q-mb-sm text-weight-bold">
          {{ campaign.name }}
        </div>
        <recurrence-calendar
          :campaign-id="campaign && campaign.campaignId"
          :start-date="campaign && campaign.startDate"
          :recurrence-type="campaign && campaign.recurrenceType"
          :custom-interval="campaign && campaign.customInterval"
          :lead-time-days="campaign && campaign.leadTimeDays"
          :messaging-purpose="campaign && campaign.messagingPurpose"
          :end-date="campaign && campaign.endDate"
        />
      </q-card-section>

      <q-card-actions align="right" class="q-pa-md">
        <q-btn :label="$gettext('CLOSE')" color="primary" flat v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import RecurrenceCalendar from './RecurrenceCalendar.vue'

@Component({
  name: 'CampaignCalendarModal',
  components: { RecurrenceCalendar }
})
class CampaignCalendarModal extends Vue {
  showModal = false
  campaign = null

  open (campaign) {
    this.campaign = campaign
    this.showModal = true
  }

  onHide () {
    this.campaign = null
  }
}

export default CampaignCalendarModal
</script>

<style lang="stylus" scoped>
.campaign-calendar-modal
  min-width: 560px
  max-width: 90vw

.campaign-name
  font-size: 0.95rem
  color: #223046
</style>
